/**
 * WO-B (G-139 parts 5–6, OD-198): the line under a figure that says what it
 * leaves out for want of a cost ("3 sales include stock of unknown cost").
 * The words come from `utils/unknownCost.ts`; nothing when there is no note.
 */
export function CostNote({ note }: { note: string | null | undefined }) {
  return note ? <small className="cost-note">{note}</small> : null;
}
